import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactPlayer from 'react-player';
import './VideoPlayer_child.scss';
import fnc from '../mymod/commFunction';

const VideoPlayer_child = ({ url, selectedItem, onPlay, childUrlList }) => {
    const selectedUserInfo = useSelector((state) => state.reduxIgong.selectedUserInfo);
    const [currentUrl, setCurrentUrl] = useState(url);
    const [serverWatchRate, setServerWatchRate] = useState(0);
    const [watchedSeconds, setWatchedSeconds] = useState(0);
    const [duration, setDuration] = useState(0);
    const [watchRate, setWatchRate] = useState(selectedItem.watchRate || 0);
    const [selectedCode, setSelectedCode] = useState(null);
    const lastPlayedSeconds = useRef(0);
    const lastSaved = useRef(0);
    const stCode = selectedUserInfo.stCode;
    // 10초마다 실시간 저장
    useEffect(() => {
        const rate = duration > 0 ? Math.min(100, Math.round((watchedSeconds / duration) * 100)) : 0;
        setWatchRate(rate);
        if (!serverWatchRate) return;
        if (serverWatchRate >= rate) return;
        if (watchedSeconds === 0) return;
        if (!selectedCode) return; // code가 없으면 저장하지 않음

        // 10초마다 저장
        if (Math.floor(watchedSeconds / 10) > Math.floor(lastSaved.current / 10)) {
            savePlayProgress({
                code: selectedCode, // 또는 code값을 따로 전달
                stCode,
                watchedSeconds: Math.floor(watchedSeconds),
                duration: Math.floor(duration),
                watchRate: rate
            });
            lastSaved.current = watchedSeconds;
        }

         // 100% 도달 시 즉시 저장
        if (rate === 100) {
            savePlayProgress({
                code: selectedCode,
                stCode,
                watchedSeconds: Math.floor(watchedSeconds),
                duration: Math.floor(duration),
                watchRate: rate
            });
            lastSaved.current = watchedSeconds;
            return;
        }
       
    }, [watchedSeconds, currentUrl, duration, selectedCode, serverWatchRate]);

    
    // 시청 진행률 저장 함수
    function savePlayProgress({ code, stCode, watchedSeconds, duration, watchRate }) {
        return fnc.sendAxios('/videoEduRoutes/insert/video_eduProgram_playProgress', {
            code, stCode, watchedSeconds, duration, watchRate }, (res) => {
            // 성공/실패 처리 필요시 여기에
            // console.log(res);
        });
    }


    // 부모에서 url이 바뀌면 동기화
    useEffect(() => {
console.log(selectedItem, '========= selectedItem');
        // alert(selectedItem.code)
        setCurrentUrl(url);
        setWatchedSeconds(0);
        setDuration(0);
        lastPlayedSeconds.current = 0;
        setSelectedCode(selectedItem.code);
        // alert(selectedItem.watchRate)
        setServerWatchRate(selectedItem.watchRate);
    }, [url, selectedItem]);

    function onClickChild(item) {
        setCurrentUrl(item.url);
        setWatchedSeconds(0);
        setDuration(0);
        lastPlayedSeconds.current = 0;
        setSelectedCode(item.code);
        console.log(item, '========= child item');
        setServerWatchRate(item.watchRate);
      

    }

    // function handleProgress(state) {
    // state.played: 0~1 (재생 비율)
    // state.playedSeconds: 현재 재생 시간(초)
    // state.loaded: 0~1 (버퍼링된 비율)
    // state.loadedSeconds: 버퍼링된 시간(초)
    // 예시: 80% 이상 시청 체크
    // if (state.played >= 0.8) { ... }
    // console.log(state);
    // console.log(state.played);
    // }

 // 누적 시청 시간 계산 (스킵 구간 제외)
    function handleProgress(state) {
        // state.playedSeconds: 현재 재생 위치(초)
        // state.played: 0~1 (진행률)
        if (duration === 0) return;
        const diff = Math.abs(state.playedSeconds - lastPlayedSeconds.current);
        // 2초 이상 점프(스킵)한 경우는 누적하지 않음
        if (diff < 2) {
            setWatchedSeconds(prev => {
                // 중복 누적 방지
                if (Math.abs(state.playedSeconds - prev) > 1) {
                    return prev + diff;
                }
                return prev;
            });
        }
        lastPlayedSeconds.current = state.playedSeconds;
    }

    function handleDuration(d) {
        setDuration(d);
    }



    
    //===========================================================
    return (
        <div className='VideoPlayer_child'>
            <section className="video-container">
                <ReactPlayer
                    url={currentUrl}
                    className='react-player'
                    width='100%'
                    height='100%'
                    controls={true}
                    onPlay={onPlay}
                    onProgress={handleProgress} // 추가
                    onDuration={handleDuration}
                    config={{
                        youtube: {
                            playerVars: { modestbranding: 1 }
                        }
                    }}
                />

                <div style={{marginTop: '0.5rem', color: '#1565c0', fontWeight: 600}}>
                    시청률: {watchRate}%
                </div>
               
            </section>

           <section className='sec-list'>
            {childUrlList && childUrlList.length > 0 && (
                <div className="child-url-flex">
                    {childUrlList.map((item, idx) => (
                        <div
                            key={idx}
                            className={
                                "child-url-item" + (item.url === currentUrl ? " active" : "")
                            }
                            onClick={() => onClickChild(item)}
                        >
                            <span className="child-url-index">{idx + 1}</span>
                            <span className="child-url-title"
                                style={!item.pCode ? { fontWeight: 'bold' } : {}}
                            >{item.title}</span>
                            <span>{item.watchRate}%</span>
                        </div>
                    ))}
                </div>
            )}
        </section>
        </div>
    );
};

export default VideoPlayer_child;